import React from 'react';
import { Draggable } from 'react-beautiful-dnd';
import classNames from 'classnames';
import { ExcelFields } from '../../types/api';
import styles from './ExportExcelModal.module.scss';

type DraggableItemProps = {
  item: ExcelFields;
  index: number;
};

export const DraggableItem = ({ item, index }: DraggableItemProps) => (
  <Draggable draggableId={item.field} index={index}>
    {(provided, snapshot) => (
      <div
        className={classNames(styles.itemContainer, snapshot.isDragging && styles.dropOver)}
        ref={provided.innerRef}
        {...provided.dragHandleProps}
        {...provided.draggableProps}
      >
        <p>{item.text}</p>
      </div>
    )}
  </Draggable>
);
